export default "__VITE_ASSET__brXG_CBW__"